/**
 * Tags the "*Sale Exclusion" product badge with a class so CSS can colour it.
 *
 * The PLP badges are rendered (and re-rendered on filter/sort/pagination) by
 * Nosto as plain <span class="badge-box">text</span> with no identifying
 * class, so the badge can only be recognised by its text. The PDP badge
 * (.badge-span) is matched the same way for consistency.
 *
 * Only a class is toggled, never markup or text, so Nosto's own DOM and the
 * badge identifiers are left untouched. The observer callback only changes
 * attributes, which it does not observe, so it cannot loop.
 */
(function () {
  'use strict';

  var BADGE_SELECTOR = '.badge-box, .badge-span';
  var MATCH_CLASS = 'badge--sale-exclusion';
  var TEXT_PATTERN = /^\*?\s*sale[\s_-]*exclusion$/i;
  var scheduled = false;

  function tagBadges() {
    scheduled = false;
    document.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
      var isMatch = TEXT_PATTERN.test(badge.textContent.trim());
      if (isMatch !== badge.classList.contains(MATCH_CLASS)) {
        badge.classList.toggle(MATCH_CLASS, isMatch);
      }
    });
  }

  function scheduleTag() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(tagBadges);
  }

  scheduleTag();
  new MutationObserver(scheduleTag).observe(document.body, { childList: true, subtree: true });
})();
